import {
  DisruptionExerciseButton,
  DisruptionExerciseButtonType,
} from "@b2bportal/core-disruption";
import {
  IconNameEnum,
  useDisruptionStyles,
  useModuleBEM,
  useTenantIcons,
} from "@b2bportal/core-themes";
import { CoreDisruptionComponent } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./DisruptionExerciseNoFlightsAvailable.module.scss";
export interface DisruptionExerciseNoFlightsAvailableProps {
  headerImage?: string;
  onSupportClick: () => void;
  onRefundClick: () => void;
}

export const DisruptionExerciseNoFlightsAvailable = (
  props: DisruptionExerciseNoFlightsAvailableProps
) => {
  const { t } = useI18nContext();
  const COMPONENT_KEY =
    CoreDisruptionComponent.DisruptionExerciseNoFlightsAvailable;
  const styles = useDisruptionStyles(COMPONENT_KEY, defaultStyles);
  const [, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const icons = useTenantIcons();
  const noFlightsIconName = icons[IconNameEnum.disruptionNoFlightsIcon]
    ? IconNameEnum.disruptionNoFlightsIcon
    : IconNameEnum.tenantLogo;

  return (
    <div className={cn("disruptionExerciseNoFlightsContent")}>
      <Icon
        iconName={noFlightsIconName}
        className={cn("header-image-container")}
      />
      <div className={cn("title")}>
        {t(
          "core-disruption.disruptionUniversalExercise.rebook.flightShopPage.noFlightsTitle"
        )}
      </div>
      <div className={cn("subtitle")}>
        {t(
          "core-disruption.disruptionUniversalExercise.rebook.flightShopPage.noFlightsSubtitle"
        )}
      </div>
      <div className={clsx(cn("disruptionExerciseActionsRoot"), cn("center"))}>
        <DisruptionExerciseButton
          title={t(
            "core-disruption.disruptionUniversalExercise.rebook.rebookOnboardingPage.moreHelpPopup.contactSupportButton"
          )}
          onClick={props.onSupportClick}
          disabled={false}
        ></DisruptionExerciseButton>
        <br></br>
        <DisruptionExerciseButton
          title={t(
            "core-disruption.disruptionUniversalExercise.rebook.rebookOnboardingPage.moreHelpPopup.getRefundButton"
          )}
          onClick={props.onRefundClick}
          disabled={false}
          type={DisruptionExerciseButtonType.Secondary}
        ></DisruptionExerciseButton>
      </div>
    </div>
  );
};

export default DisruptionExerciseNoFlightsAvailable;
